export default __webpack_public_path__ + "static/media/ta-loader.a6c1f1b4.gif";